<template>
<div id="about-cultural" class="cultural" data-aos="fade-down" :data-aos-duration="1500">
  <div class="cultural-row">
    <div class="about-cultural-img">
      <img src="http://www.energyst.cn/media/article/images/%E6%96%87%E5%8C%96%E7%90%86%E5%BF%B5%E9%85%8D%E5%9B%BE_20230608163544_688.jpg" alt="05/20150514142"
           style="height: 100%">
    </div>
    <div class="about-cultural-text"  data-aos="fade-left" :data-aos-duration="1500">
      <p>Our philosophy</p>
      <p>精神, 企业之魂</p>
      <p>诚信为本，创新为质</p>
      <br/>
      <p>—— 我们的理念</p>
      <p>以人为本：尊重和信任每位员工，重视每位员工的贡献，激发员工的热情和积极性，满足员工合理需求，保障并提高员工的经济利</p>
      <p>专业创新：以专业的技术服务和卓越的产品吸引客户，积极创新，优化配置公司资源，向客户输送高品质的服务和产品。</p>
      <p>共同发展：客户、员工及股东建立相互信任和稳定的战略联盟关系，共同实现利益的增值。</p>
      <br/>
      <p>—— 我们的愿景</p>
      <p>坚持自主创新，以独具优势的产品和技术开拓市场、引领市场需求，在产品、技术、管理、</p>
      <p>人才等方面成为行业领先，成为最具 影响力的水利水电行业先进的国际科技 企业，与客户实现价值分享。</p>
      <div class="about-cultural-title">
        <h1>公司文化理念</h1>
        <span>———</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Cultural"
}
</script>

<style scoped lang="less">
.cultural {
  margin: 80px 0;

  .cultural-row {
    display: flex;
    justify-content: center;
    background-color: #f2f2f4;

    .about-cultural-img {
      min-width: 800px;
      overflow: hidden;
    }

    .about-cultural-text {
      position: relative;
      padding: 40px 50px;
      width: 1100px;
      min-height: 500px;
      font-size: 16px;
      line-height: 35px;
      box-sizing: border-box;


      .about-cultural-title {
        position: absolute;
        top: 40px;
        right: 0;
        padding: 30px 0 0 50px;
        width: 55%;
        min-width:300px;
        height: 90px;
        background-color: #1E55AE;

        h1, span {
          font-size: 35px;
          line-height: 35px;
          color: white;
        }
      }
    }
  }
}
</style>